<mat-tab-group #myTabGroup [selectedIndex]="isInforTab" (selectedIndexChange)="isInforTab = $event">
  <mat-tab [label]="'add_document_moha.labor_contract_report_information' | translate">
  </mat-tab>
  <mat-tab [label]="'add_document_moha.criteria_update_history' | translate">
    <mat-card-content class="mb-3 mat-card-content-contract-sm" style="overflow-y: auto; width: 100%; overflow-x: hidden;">
      <div class="table-container" style=" display: block;max-height: 590px">
        <table mat-table [dataSource]="listDataVersionHistory" class="mat-table-col-extra-sm mat-table table table-history">
          <ng-container *ngFor="let col of displayedHistoryColumns" [matColumnDef]="col">
            <th mat-header-cell *matHeaderCellDef 
            class="col-cell" 
            [matTooltip]="getField(col)?.name"
            matTooltipPosition="above">
              {{ getField(col)?.name }}
            </th>
            <td mat-cell *matCellDef="let element" class="col-cell"
            [ngClass]="{
              'text-left': getField(col)?.inputType !== 'DATETIME',
              'text-center': getField(col)?.inputType === 'DATETIME'
            }"
            [matTooltip]="getField(col)?.inputType === 'DATETIME' 
            ? (element[col] ? getFormatDate(element[col]) : '')
            : element[col]"
            matTooltipPosition="above"
            >
              <ng-container [ngSwitch]="getField(col)?.inputType">
        
                <!-- DATETIME -->
                <span *ngSwitchCase="'DATETIME'"
                >
                  {{ element[col] ? getFormatDate(element[col]) : '' }}
                </span>
                <span *ngSwitchCase="'DROPDOWN'"
                style="white-space: nowrap;"
                >
                  {{getDataDropdown(getField(col), element[col])}}
                </span>
                <!-- DEFAULT -->
                <span *ngSwitchDefault
                style="white-space: nowrap;"
                >
                  {{ element[col] }}
                </span>
              </ng-container>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedHistoryColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedHistoryColumns;"></tr>
        </table>
      </div>
    </mat-card-content>
      <div mat-dialog-actions class="justify-content-center" style="margin-top: 24px;">
        <button mat-stroked-button color="primary" class="mr-3" [mat-dialog-close]="true">
          <mat-icon class="mr-0">cancel</mat-icon>
          {{'button.close' | translate}}
        </button>
      </div>
  </mat-tab>
</mat-tab-group>
<mat-card class="form-view-step-3" [ngClass]="isInforTab === 0 ? '' : 'd-none'">
  <mat-divider></mat-divider>
  <mat-card-content class="mb-3 mat-card-content-contract-sm" style="overflow-y: auto; height: 600px; width: 100%; overflow-x: hidden;">
    <div class="row" style="overflow-y: auto">
      <div class="col-12" style="padding-right: 0;">
        <mat-accordion #accordion="matAccordion" [multi]="true">
          <mat-expansion-panel expanded="true" class="mt-3 mat-elevation-z0">
            <div class="row mt-2">
              <div class="col-4" style="padding-left: 28px;">
                <mat-form-field class="w-100 dynamic-view">
                  <input style="font-weight: 500; color: black;" matInput type="text" [value]="customerMohaName" [placeholder]="'add_document_moha.employee' | translate" disabled/>
                </mat-form-field>
              </div>
            </div>
            <!-- Tiêu chi mặc định  -->
            <mat-expansion-panel expanded="true" class="mt-3 mat-elevation-z0">
              <mat-expansion-panel-header>
                <mat-panel-description class="mat-panel-title">
                  {{ "add_document_moha.list_report_info_contract" | translate }} &nbsp;
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div>
                <mat-table [dataSource]="listDataSource" class="mat-table-col-extra-sm mat-table table" matSort>
                  <!-- STT -->
                  <ng-container matColumnDef="stt">
                    <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                      {{ "headertable.stt" | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                      {{ element.stt }}
                    </mat-cell>
                  </ng-container>
                  <!-- Tên tiêu chí -->
                  <ng-container matColumnDef="nameCriteria">
                    <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                      {{ "add_document_moha.criteria_name" | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index" class="mat-header-cell-center mat-cell-non-boder-right-bottom cell">
                      <span class="fix-width fw-100 nameDoc">
                        {{ element.name }} 
                        <!-- <span *ngIf="element.isRequired" style="color: red">*</span> -->
                      </span>
                    </mat-cell>
                  </ng-container>
                  <!-- Trường thông tin của mẫu -->
                  <ng-container matColumnDef="infoTemplate">
                    <mat-header-cell *matHeaderCellDef class="text-center mat-header-cell-center mat-cell-non-boder-right-bottom">
                      {{ "add_document_moha.labor_contract_report_field" | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index" class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                      <ng-container [ngSwitch]="element.inputType">
                        <mat-form-field class="w-100 dynamic-view" *ngSwitchCase="'TEXT'">
                          <textarea matInput readonly cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" rows="1" class="textarea-auto w-100" [formControl]="element.controlField" 
                            style="resize: none; height: fit-content !important; min-height: 22px !important;"></textarea>
                        </mat-form-field>
                        <mat-form-field class="w-100 dynamic-view" *ngSwitchCase="'DROPDOWN'">
                          <mat-select [id]="element.id" [formControl]="element.controlField" disabled>
                            <mat-option *ngFor="let data of optionsMap.get(element.id)" [value]="data.value">
                              {{ data.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="w-100 dynamic-view" *ngSwitchCase="'DATETIME'">
                          <input #pickerInput matInput [matDatepicker]="datePicker"
                            [name]="'datetimeControl-' + i" autocomplete="off"
                            [formControl]="element.controlField" disabled/>
                          <mat-datepicker #datePicker></mat-datepicker>
                        </mat-form-field>
                        <ng-container *ngSwitchDefault>
                          default case
                        </ng-container>
                      </ng-container>
                    </mat-cell>
                  </ng-container>
  
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns" class="element-row">
                  </mat-row>
                </mat-table>
              </div>
            </mat-expansion-panel>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </mat-card-content>
  <div mat-dialog-actions class="justify-content-center">
    <button mat-stroked-button color="primary" class="mr-3" [mat-dialog-close]="true">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.close' | translate}}
    </button>
  </div>
</mat-card>